<template>
  <div class="upload-picture-container">
    <div v-for="(item, index) in dataList" :key="index" class="upload-wrap" @click="handleItemClick(item.type)">
      <div>
        <p class="title">{{ item.title }}</p>
        <p class="description">{{ item.desc }}</p>
      </div>
      <img class="icon" :src="require(`../resource/${item.type}.png`)" alt="" />
    </div>
  </div>
</template>

<script>
import { track } from '@kd/loggerh5';

export default {
  setup(props, ctx) {
    const { root } = ctx;
    const dataList = [
      {
        type: 'camera',
        title: '拍照',
        desc: '上传用相机，收录更容易'
      },
      {
        type: 'picture',
        title: '相册',
        desc: '选择相册素材上传'
      },
      {
        type: 'delete',
        title: '删除头像',
        desc: ''
      },
      {
        type: 'decorate',
        title: '修改头像框',
        desc: '进入头像框中心进行选择'
      }
    ];

    const uploadAvatar = async uploadType => {
      window.__kd_needReload__ = 0;
      ctx.emit('closePop'); // 关闭上传头像弹框
      const { url } = await root.hybrid('app_kdzy_upload_user_avatar', { type: uploadType, showToast: 0 });
      // url存在表示上传成功
      if (url) {
        const params = {
          updateKey: 'avatar',
          updateValue: url
        };
        try {
          const result = await root.$http.entryV2(root.api.updateuserinfo, params);
          const { errNo } = result;
          // 成功
          if (Number(errNo) === 0) {
            if (root.$cmn.os === 'ios') {
              root.hybrid('toast', { text: '上传成功请等待审核', type: 1 });
            } else {
              root.hybrid('toast', { text: '上传成功请等待审核' });
            }
            root.hybrid('app_kdzy_set_user_info', {
              key: 'avatar',
              value: url
            });
          }
        } catch (e) {
          console.log('line59~~~~', e);
          if (root.$cmn.os === 'ios') {
            root.hybrid('toast', { text: e.message || e.errstr || '头像审核中请等待结果', type: 3 });
          } else {
            root.hybrid('toast', { text: e.message || e.errstr || '头像审核中请等待结果' });
          }
        }
      } else {
        if (root.$cmn.os === 'ios') {
          root.hybrid('toast', { text: '上传失败', type: 2 });
        } else {
          root.hybrid('toast', { text: '上传失败' });
        }
      }
      window.__kd_needReload__ = 1;
    };

    const gotoDecorate = () => {
      track('KPA_008');
      ctx.emit('closePop');
      root.route({
        appName: 'app-extend',
        module: 'user-decorate',
        options: {
          hideNavBar: 1,
          hideStatusBar: 0,
          hideNativeTitleBar: 1,
          staBarFull: 1,
        },
        params: {
          from: 'personalcenterpopup'
        }
      });
    };

    const handleItemClick = type => {
      if (type === 'decorate') {
        gotoDecorate();
        return;
      }
      uploadAvatar(type);
    };

    return {
      dataList,
      handleItemClick
    };
  }
};
</script>

<style lang="less" scoped>
.upload-picture-container {
  width: 100%;
  height: 100%;
  padding: 94px 40px 64px 40px;
  box-sizing: border-box;
  .upload-wrap {
    width: 632px;
    height: 140px;
    background: rgba(247, 249, 250, 1);
    border-radius: 16px;
    padding: 0 40px;
    box-sizing: border-box;
    position: relative;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    .title {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(20, 20, 20, 1);
      line-height: 32px;
    }
    .description {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(157, 160, 163, 1);
      line-height: 24px;
      margin-top: 20px;
    }
    .icon {
      display: inline-block;
      width: 64px;
      height: 64px;
      background-size: 100%;
      position: absolute;
      top: 38px;
      right: 40px;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
